const HOST_NAME = "https://www.minut.com/lp/referral"
const SEARCH_PARAM = "mwr"

export function generateReferalLink(code: string) {
  return `${HOST_NAME}?${SEARCH_PARAM}=${code}`
}
